import { useMemo } from 'react'

/** Мерцающие звёзды на фоне. Позиции считаются один раз за монтирование. */
export function Starfield({ count = 18 }: { count?: number }) {
  const stars = useMemo(
    () =>
      Array.from({ length: count }, () => ({
        x: Math.random() * 96,
        y: Math.random() * 92,
        s: Math.random() * 1.6 + 0.8,
        d: Math.random() * 3 + 2.5,
        g: Math.random() * 3,
      })),
    [count],
  )

  return (
    <div className="starfield" aria-hidden="true">
      {stars.map((st, i) => (
        <i
          key={i}
          style={{
            left: `${st.x}%`,
            top: `${st.y}%`,
            width: `${st.s}px`,
            height: `${st.s}px`,
            animationDuration: `${st.d}s`,
            animationDelay: `${st.g}s`,
          }}
        />
      ))}
    </div>
  )
}
